import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { store } from 'flow/configure-store';
import { setAppEmbedded } from 'flow/actions/embedded-app-actions';
import EmbeddedType from 'flow/types/embedded-type';
import { isTheOnlyRegistration } from 'flow/utils/instance-count-utils';
import { disconnectApp } from 'flow/actions/navigate-actions';
import { isEmbeddedTypeCti } from 'flow/utils/app-utils';
import { tooManyInstances } from 'flow/actions/cti-actions';
import { allowMultipleInstancesOnOpen } from 'flow/utils/cti-config-utils';
import { addGeneralLogEntry, getQueryParam } from 'flow/utils/browser-utils';
import { setCTIApiHost } from 'flow/utils/is-integration';
import { UserRegionContext } from 'flow/contexts/UserRegionProvider';

class EmbedApplication extends React.PureComponent {
    static contextType = UserRegionContext;

    static propTypes = {
        match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
        location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    };

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
        };
    }

    componentDidMount() {
        const {
            match: { params },
            location,
        } = this.props;

        const embeddedType = EmbeddedType.get(params.type);

        this.context?.setEmbedType(embeddedType);
        if (embeddedType) {
            store.dispatch(setAppEmbedded(embeddedType));
            this.setState({ redirect: true }); // eslint-disable-line react/no-did-mount-set-state

            if (isEmbeddedTypeCti(embeddedType)) {
                setCTIApiHost();
                const { search } = location;
                const hostDescription = getQueryParam(search, 'config');

                const isNotTheOnlyRegistration = !isTheOnlyRegistration();
                const doesNotAllowMultipleRegistrationsOnOpen =
                    !allowMultipleInstancesOnOpen(hostDescription);
                const redirectToLogin =
                    isNotTheOnlyRegistration &&
                    doesNotAllowMultipleRegistrationsOnOpen;

                if (redirectToLogin) {
                    store
                        .dispatch(disconnectApp(embeddedType, false))
                        .catch((error) => {
                            addGeneralLogEntry(
                                `Error in disconnect app: ${error}`,
                            );
                        });
                    store.dispatch(tooManyInstances(true));
                }
            }
        } else {
            console.warn(`Failed to embed application of type: ${params.type}`);
        }
    }

    render() {
        const {
            match: { params },
        } = this.props;

        if (this.state.redirect) {
            return (
                <Redirect
                    to={`/${(params[0] || '') + window.location.search}`}
                />
            );
        }

        return null;
    }
}

export default EmbedApplication;
